import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';

/**
 * Layout for several pages
 */
@Component({
    selector: 'sona-general-layout',
    imports: [],
    templateUrl: './general.layout.html',
    styleUrls: ['./general.layout.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'c-sona-general-layout'
    }
})
export class SonaGeneralLayout {

    readonly headerContainerClass = input<string>('tw-container');
    readonly contentContainerClass = input<string>('tw-container');
}
